export default __webpack_public_path__ + "static/ma-image-1be440dcdc34cc070e9844fcb6e804bf.svg";